import React, { useState, useEffect } from "react";
import styles from "./AnomalyReports.module.css";
import {
  Row,
  Col,
  Card,
  Tooltip,
  Space,
  Spin,
  Select,
  message,
  Modal,
  Table,
} from "antd";
import { Bar } from "react-chartjs-2";
import "chartjs-plugin-datalabels";
import { fetchJsData } from "../../../../api";
const { Option } = Select;

const DETECTIONPRO = {
  eventDetection: {
    label: "Event Anomaly",
    table: "event_detection_report",
    type: "eventDetection",
  },
  instanceDetection: {
    label: "Instance Anomaly",
    table: "instance_detection_report",
    type: "instanceDetection",
  },
};

const AnomalyReports = () => {
  const [loading, setLoading] = useState(true);
  const [graphRange, setGraphRange] = useState(12);
  const [submit, setSubmit] = useState(true);
  const [chngLoad, setChngLoading] = useState(true);
  const [graphData, setGraphData] = useState({
    eventDetection: {
      label: [],
    },
    instanceDetection: {
      label: [],
    },
  });

  useEffect(() => {
    fetchGraphData();
  }, [submit]);

  const fetchGraphData = async () => {
    setLoading(true);
    const eventDet = await fetchJsData({
      type: "fetch",
      qry: "fetEventDetRep",
      preProcess: true,
      preProcFunc: "fetAnomalyDetectionReport",
      firstVal: graphRange,
    });

    const instanceDet = await fetchJsData({
      type: "fetch",
      qry: "fetInstanceDetRep",
      preProcess: true,
      preProcFunc: "fetAnomalyDetectionReport",
      firstVal: graphRange,
    });
    graphData.eventDetection = eventDet.data.graphData;
    graphData.instanceDetection = instanceDet.data.graphData;
    setGraphData(graphData);
    setLoading(false);
    setChngLoading(!chngLoad);
  };

  function onChangeGraphRange(value) {
    if (value == "100") {
      message.info(`All Months Selected`);
    } else {
      message.info(`${value} Months Selected`);
    }
    setGraphRange(parseInt(value));
    setSubmit(!submit);
  }

  return (
    <>
      {/* date range filter */}
      <Row gutter={16} style={{ margin: "5px", padding: "1px" }}>
        <Col className="gutter-row" span={1}></Col>
        <Col span={14}>
          <Card
            bordered={false}
            style={{ height: 70, margin: "1px", padding: "1px" }}
          >
            <Tooltip title="Month Filter">
              <Space>
                <Select
                  showSearch
                  defaultValue={"last " + graphRange + " Months"}
                  style={{ width: 400 }}
                  placeholder="Month Filter"
                  optionFilterProp="children"
                  onChange={onChangeGraphRange}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option value="6">last 6 Months</Option>
                  <Option value="12">last 12 Months</Option>
                  <Option value="24">last 24 Months</Option>
                  <Option value="100">All Months</Option>
                </Select>
              </Space>
            </Tooltip>
          </Card>
        </Col>
      </Row>
      <Row gutter={16} style={{ margin: "5px", padding: "1px" }}>
        <Col className="gutter-row" span={1}></Col>
        <Col span={22}>
          <Card
            size={"small"}
            title={DETECTIONPRO.eventDetection.label}
            headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
            bordered={false}
            style={{ margin: "1px", padding: "1px" }}
          >
            <BarGraph
              label={graphData.eventDetection?.label}
              graphData={graphData}
              detectionType={DETECTIONPRO.eventDetection.type}
              chngLoad={chngLoad}
              submit={submit}
              datasets={[
                datasetUseCov({
                  lineHead: "True Anomaly",
                  data: graphData.eventDetection?.TP,
                  dataLabelAlign: dataLabelMiddle,
                  stackGroup: "Stack 0",
                  color: graphColors.green,
                }),
                datasetUseCov({
                  lineHead: "False Anomaly",
                  data: graphData.eventDetection?.FP,
                  dataLabelAlign: dataLabelMiddle,
                  stackGroup: "Stack 0",
                  color: graphColors.yellow,
                }),
                datasetUseCov({
                  lineHead: "Missed Anomaly",
                  data: graphData.eventDetection?.FN,
                  dataLabelAlign: dataLabelMiddle,
                  stackGroup: "Stack 0",
                  color: graphColors.red,
                }),
                datasetUseCov({
                  lineHead: "Open Anomaly",
                  data: graphData.eventDetection?.Open,
                  dataLabelAlign: dataLabelMiddle,
                  stackGroup: "Stack 0",
                  color: graphColors.grey,
                }),
              ]}
              options={gradientBarTooltip}
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={16} style={{ margin: "5px", padding: "1px" }}>
        <Col className="gutter-row" span={1}></Col>
        <Col span={22}>
          <Card
            size={"small"}
            title={DETECTIONPRO.instanceDetection.label}
            headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
            bordered={false}
            style={{ margin: "1px", padding: "1px" }}
          >
            <BarGraph
              label={graphData.instanceDetection?.label}
              loading={loading}
              graphData={graphData}
              detectionType={DETECTIONPRO.instanceDetection.type}
              chngLoad={chngLoad}
              submit={submit}
              datasets={[
                datasetUseCov({
                  lineHead: "True Anomaly",
                  data: graphData.instanceDetection?.TP,
                  dataLabelAlign: dataLabelMiddle,
                  stackGroup: "Stack 0",
                  color: graphColors.green,
                }),
                datasetUseCov({
                  lineHead: "False Anomaly",
                  data: graphData.instanceDetection?.FP,
                  dataLabelAlign: dataLabelMiddle,
                  stackGroup: "Stack 0",
                  color: graphColors.yellow,
                }),
                datasetUseCov({
                  lineHead: "Missed Anomaly",
                  data: graphData.instanceDetection?.FN,
                  dataLabelAlign: dataLabelMiddle,
                  stackGroup: "Stack 0",
                  color: graphColors.red,
                }),
                datasetUseCov({
                  lineHead: "Open Anomaly",
                  data: graphData.instanceDetection?.Open,
                  dataLabelAlign: dataLabelMiddle,
                  stackGroup: "Stack 0",
                  color: graphColors.grey,
                }),
              ]}
              options={gradientBarTooltip}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

const BarGraph = (props) => {
  let modalTableColumn = [
    {
      title: "App Name",
      dataIndex: "appname",
      key: "appname",
      fixed: "left",
      width: "35%",
    },
    {
      title: "Activity",
      dataIndex: "activities",
      key: "activities",
      fixed: "left",
      width: "10%",
    },
    {
      title: "MP",
      dataIndex: "mp",
      key: "mp",
      fixed: "left",
      width: "10%",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      fixed: "left",
      width: "12%",
    },
    {
      title: "Detection Date",
      dataIndex: "detection_date",
      key: "detection_date",
      fixed: "left",
      width: "15%",
      render: (text) => <>{text.split("T")[0]}</>,
    },
  ];

  const [loading, setLoading] = useState(props.loading);
  const [lineData, setLineData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalLoading, setModalLoading] = useState(false);
  const [modalTableData, setModalTableData] = useState([]);
  const [modalTableCol, setModalTableCol] = useState(modalTableColumn);
  const graphData = props.graphData;
  useEffect(() => {
    setLoading(true);
    setLineData({
      trend: props.trendData,
      label: props.label,
      dataSet: props.datasets,
      options: props.options,
      detectionType: props.detectionType,
    });
    setLoading(false);
  }, [props.chngLoad]);

  const fetchOnClickGraphData = async (type, date) => {
    setModalLoading(true);
    const report = await fetchJsData({
      type: "fetch",
      qry: "fetDetRepByDate",
      firstVal: DETECTIONPRO[lineData?.detectionType].table,
      secondVal: "%" + date + "%",
    });
    if (type == DETECTIONPRO.instanceDetection.type) {
      let instCol = modalTableColumn;
      instCol.push({
        title: "Tenant ID",
        dataIndex: "tenant_id",
        key: "tenant_id",
        fixed: "left",
        width: "10%",
      });
      setModalTableCol(instCol);
    }
    setModalTitle(DETECTIONPRO[type].label);
    const typeForm = {
      TP: "True Anomaly",
      FP: "False Anomaly",
      FN: "Missed Anomaly",
      Open: "Open Anomaly",
    };
    let tableData = report.data.map((t) => {
      t.type = typeForm.hasOwnProperty(t.type) ? typeForm[t.type] : "";
      return t;
    });
    setModalTableData(tableData);
    setModalLoading(false);
  };

  const onGraphElementClickEventDet = (event) => {
    if (!event) return;
    if (event.length == 0) return;
    let date = graphData[lineData.detectionType].oriLabel[event[0]?._index];
    setShowModal(true);
    fetchOnClickGraphData(lineData.detectionType, date);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalTitle("");
    setModalTableCol(modalTableColumn);
    setModalTableData([]);
  };

  return (
    <>
      {loading ? (
        <Spin className={styles.spinner} size="small" />
      ) : (
        <Card
          size="small"
          headStyle={{ backgroundColor: "#FDEEF4", border: 0 }}
          bordered={false}
        >
          <Bar
            height={100}
            data={{
              labels: lineData["label"],
              datasets: lineData["dataSet"],
            }}
            options={lineData.options}
            getElementAtEvent={onGraphElementClickEventDet}
          />
        </Card>
      )}
      <Modal
        title={modalTitle}
        visible={showModal}
        onCancel={closeModal}
        width={"70%"}
      >
        <Table
          size="small"
          bordered
          dataSource={modalTableData}
          columns={modalTableCol}
          pagination={false}
          loading={modalLoading}
        />
      </Modal>
    </>
  );
};

const datasetUseCov = (graphDataset) => {
  let graphType = graphDataset.graphType ? graphDataset.graphType : "bar";
  let yAxis = graphDataset.yAxis ? graphDataset.yAxis : "";
  return {
    type: graphType,
    yAxisID: yAxis,
    label: graphDataset.lineHead,
    fill: false,
    barPercentage: 0.6,
    categoryPercentage: 0.6,
    backgroundColor: graphDataset.color + ", 0.5)",
    hoverBackgroundColor: graphDataset.color + ", 0.8)",
    borderColor: graphDataset.color + ", 132)",
    borderWidth: graphType == "line" ? 3 : 2,
    borderDash: [],
    borderDashOffset: 0.0,
    data: graphDataset.data,
    datalabels: graphDataset.dataLabelAlign,
    stack: graphDataset.stackGroup,
    comments: "comments" in graphDataset ? graphDataset.comments : [],
    originalValue:
      "originalValue" in graphDataset ? graphDataset.originalValue : [],
  };
};

const toolTip = {
  backgroundColor: "#f5f5f5",
  titleFontColor: "#333",
  bodyFontColor: "#666",
  bodySpacing: 4,
  xPadding: 12,
  mode: "nearest",
  intersect: 0,
  position: "nearest",
};

const gradientBarTooltip = {
  tooltips: toolTip,
  skipNull: true,
  legend: {
    position: "bottom",
  },
  responsive: true,
  interaction: {
    intersect: false,
  },
  scales: {
    yAxes: [
      {
        id: "A",
        position: "left",
      },
      {
        id: "B",
        position: "right",
        display: "auto",
        gridLines: [
          {
            display: false,
          },
        ],
      },
    ],
  },
};

const dataLabelTop = {
  align: "end",
  color: "black",
};
const dataLabelTopRight = {
  align: "right",
  color: "black",
};
const dataLabelBottom = {
  align: "start",
  color: "black",
};
const dataLabelMiddle = {
  align: "center",
  color: "black",
};

const graphColors = {
  green: "rgba(0, 255, 0",
  darkgreen: "rgba(0, 153, 26",
  red: "rgba(255, 0, 0",
  blue: "rgba(0, 0, 255",
  skyblue: "rgba(0, 204, 255",
  orange: "rgba(245, 94, 0",
  grey: "rgba(128, 128, 128",
  yellow: "rgba(255, 255, 0",
};

export default AnomalyReports;
